import AdminRequestManagementNavigation from './AdminRequestManagementNavigation';
class Parent {
    static NavMain = {
        id: "nav-main",
        title: "nav-main",
        icon: "mdi-view-dashboard-outline",
        to: "adminMainPage",
        subItems: [],
        order: 1,
    };
    static PersonelShow = {
        id: "nav-personel-show",
        title: "nav-personel-show",
        icon: "mdi-account-group",
        to: "adminPersonelsSection",
        subItems: [],
        order: 2,
    };
    static PresentPersonel = {
        id: "nav-present-personel",
        title: "nav-present-personel",
        icon: "mdi-account-multiple-check",
        to: "admin-present-personel",
        subItems: [],
        order: 3,
    };
    static AbsenceReport = {
        id: "nav-absence-report",
        title: "nav-absence-report",
        icon: "mdi-account-multiple-remove",
        to: "admin-absence-report",
        subItems: [],
        order: 4,
    };
    static NavIOReport = {
        id: "nav-io-report",
        title: "nav-io-report",
        icon: "mdi-transit-transfer",
        to: "",
        subItems: [],
        order: 5,
    };
    static NavPublicAccess = {
        id: "nav-public-access",
        title: "nav-public-access",
        icon: "mdi-shield-account-outline",
        to: "",
        subItems: [],
        order: 6,
    };
    static NavPattern = {
        id: "nav-pattern",
        title: "nav-add-pattern",
        icon: "mdi-car-shift-pattern",
        to: "add-pattern",
        subItems: [],
        order: 7,
    };
    static NavSectionPersonelManagment = {
        id: "nav-section-personel-management",
        title: "nav-section-personel-management",
        icon: "mdi-table-account",
        to: "sectionPersonelManagment",
        subItems: [],
        order: 8,
    };

    static NavRequestManagement = {
        id: "nav-request-managment",
        title: "nav-request-management",
        icon: "mdi-clipboard-list-outline",
        to: "",
        subItems: [],
        order: 9,
    };

    static NavFunctinality = {
        id: "nav-functionality",
        title: "nav-functionality",
        icon: "mdi-poll",
        to: "",
        subItems: [],
        order: 10,
    };

    static NavPasswordManagment = {
        id: "nav-password-management",
        title: "nav-password-management",
        icon: "mdi-lock-reset",
        to: "",
        subItems: [],
        order: 11,
    };

    /** Settings */
    static Settings = {
        id: "nav-settings",
        title: "nav-settings",
        icon: "mdi-tune",
        to: "webSettings",
        subItems: [],
        order: 12,
    };

    static NavMessages = {
        id: "nav-message",
        title: "nav-message",
        icon: "mdi-comment-text-multiple-outline",
        to: "",
        subItems: [],
        order: 13,
    };

    static NavActiveDirectory = {
        id: "nav-active-directory",
        title: "nav-active-directory",
        icon: "mdi-tune",
        to: "active-directory",
        subItems: [],
        order: 14,
    };

    // static NavPortal = {
    //     id: "nav-portal",
    //     title: "nav-portal",
    //     icon: "mdi-tune",
    //     to: "portal",
    //     subItems: [],
    //     order: 15,
    // };

    static NavMap = {
        id: "nav-map",
        title: "nav-map",
        icon: "mdi-map",
        to: "eosMap",
        subItems: [],
        order: 16,
    };
}

class Child {
    /** IO Report */
    static PersonelIoInfo = {
        id: "nav-personelioinfo",
        title: "nav-personelioinfo",
        icon: "",
        to: "adminPersonelioinfo",
        subItems: [],
        order: 1,
    };
    static IoInfoInDate = {
        id: "nav-ioinfoindate",
        title: "nav-ioinfoindate",
        icon: "",
        to: "adminIoinfoindate",
        subItems: [],
        order: 2,
    };
    static CompeleteIoSpecificDate = {
        id: "nav-compeleteio-specificdate",
        title: "nav-compeleteio-specificdate",
        icon: "",
        to: "admincompeleteioindate",
        subItems: [],
        order: 3,
    };
    static CompeleteIo = {
        id: "nav-compeleteio",
        title: "nav-compeleteio",
        icon: "",
        to: "admincompeleteio",
        subItems: [],
        order: 4,
    };

    static PublicAccess = {
        id: "nav-public-access",
        title: "nav-public-access",
        icon: "",
        to: "publicAccess",
        subItems: [],
        order: 1,
    };

    /** Functionality */
    static PersonelDayWork = {
        id: "nav-personeldaywork",
        title: "nav-personeldaywork",
        icon: "",
        to: "admin-personel-daywork",
        subItems: [],
        order: 1,
    };
    static PersonelMonthWork = {
        id: "nav-personelmonthwork",
        title: "nav-personelmonthwork",
        icon: "",
        to: "admin-personel-monthwork",
        subItems: [],
        order: 2,
    };
    static PersonelPeriodWork = {
        id: "nav-personelperiodwork",
        title: "nav-personelperiodwork",
        icon: "",
        to: "admin-personel-periodwork",
        subItems: [],
        order: 3,
    };

    /** Password Management */
    static ChangePassword = {
        id: "nav-change-password",
        title: "nav-change-password",
        icon: "",
        to: "admin-change-password",
        subItems: [],
        order: 1,
    };
    static ResetPersonelPass = {
        id: "nav-reset-password",
        title: "nav-reset-password",
        icon: "",
        to: "admin-reset-password",
        subItems: [],
        order: 2,
    };

    /**
     *  Messages
     */
     static Inbox = {
        id: "nav-inbox",
        title: "nav-inbox",
        icon: "",
        to: "admin-inbox",
        subItems: [],
        order: 1,
    };
    static OutBox = {
        id: "nav-outbox",
        title: "nav-outbox",
        icon: "",
        to: "admin-outbox",
        subItems: [],
        order: 2,
    };
    static SendMessage = {
        id: "nav-send-message",
        title: "nav-send-message",
        icon: "",
        to: "admin-send-message",
        subItems: [],
        order: 3,
    };
}

class NavigationItems {
    constructor() { }

    items = [
        { 'id': 0, 'data': { "parent": Parent.NavMain, "item": '' } },
        { 'id': 0, 'data': { "parent": Parent.PersonelShow, "item": '' } },
        { 'id': 0, 'data': { "parent": Parent.PresentPersonel, "item": '' } },
        { 'id': 0, 'data': { "parent": Parent.AbsenceReport, "item": '' } },

        { 'id': 0, 'data': { "parent": Parent.NavIOReport, "item": Child.PersonelIoInfo } },
        { 'id': 0, 'data': { "parent": Parent.NavIOReport, "item": Child.IoInfoInDate } },
        { 'id': 0, 'data': { "parent": Parent.NavIOReport, "item": Child.CompeleteIoSpecificDate } },
        { 'id': 0, 'data': { "parent": Parent.NavIOReport, "item": Child.CompeleteIo } },

        { 'id': 0, 'data': { "parent": Parent.NavPublicAccess, "item": Child.PublicAccess } },
        { 'id': 0, 'data': { "parent": Parent.NavPattern, "item": '' } },
        { 'id': 0, 'data': { "parent": Parent.NavSectionPersonelManagment, "item": '' } },

        /**
         * RequestManagement
         */
        { 'id': 0, 'data': { "parent": Parent.NavRequestManagement, "item": new AdminRequestManagementNavigation().VacationManagement() } },
        { 'id': 0, 'data': { "parent": Parent.NavRequestManagement, "item": new AdminRequestManagementNavigation().MissionManagement() } },
        { 'id': 0, 'data': { "parent": Parent.NavRequestManagement, "item": new AdminRequestManagementNavigation().IOManagement() } },
        { 'id': 0, 'data': { "parent": Parent.NavRequestManagement, "item": new AdminRequestManagementNavigation().ExtraWorkManagement() } },

        { 'id': 0, 'data': { "parent": Parent.NavFunctinality, "item": Child.PersonelDayWork } },
        { 'id': 0, 'data': { "parent": Parent.NavFunctinality, "item": Child.PersonelMonthWork } },
        { 'id': 0, 'data': { "parent": Parent.NavFunctinality, "item": Child.PersonelPeriodWork } },

        { 'id': 0, 'data': { "parent": Parent.NavPasswordManagment, "item": Child.ChangePassword } },
        { 'id': 0, 'data': { "parent": Parent.NavPasswordManagment, "item": Child.ResetPersonelPass } },
        { 'id': 0, 'data': { "parent": Parent.Settings, "item": '' } },

        /**
         * Messages
         */
        { 'id': 0, 'data': { "parent": Parent.NavMessages, "item": Child.Inbox } },
        { 'id': 0, 'data': { "parent": Parent.NavMessages, "item": Child.OutBox } },
        { 'id': 0, 'data': { "parent": Parent.NavMessages, "item": Child.SendMessage } },

        { 'id': 0, 'data': { "parent": Parent.NavActiveDirectory, "item": '' } },
        // { 'id': 0, 'data': { "parent": Parent.NavPortal, "item": '' } },

        { 'id': 0, 'data': { "parent": Parent.NavMap, "item": '' } },

    ]

}

const NavigationList = []

const AdminNavigation = {
    getNavigationList(array = []) {
        console.log('getNavigationList');
        array.push(0)
        NavigationList.forEach((item) => item.subItems.splice(0))
        NavigationList.splice(0)

        //this.getParent(Parent.NavProfile)
        ////console.log(array);
        array.forEach((number) => {
            console.log(number);
            var navigationItems = new NavigationItems().items
            var items = navigationItems.filter((item) => {
                return item.id === number
            })
            ////console.log(items);
            if (items.length > 0) {
                items.forEach((item) => {
                    ////console.log(item.id);
                    var navItem = item.data.item
                    if (item.data.parent != "") {
                        var parent = this.getParent(item.data.parent)
                        if (navItem != '') {
                            //check duplicate
                            var duplicate = parent.subItems.find((element) => {
                                return element.id === navItem.id
                            })
                            if (!duplicate) {
                                parent.subItems.push(navItem);
                            } else {
                                ////console.log('duplicate:',duplicate);
                            }
                        }
                    } else {
                        if (navItem != '') {
                            NavigationList.push(navItem)
                        }
                    }
                });
            }
            /*var item = NavigationItems.find((item) => item.id === number);
            if (item != null) {
                ////console.log(item.id);
                var navItem = item.data.item
                if (item.data.parent != "") {
                    var parent = this.getParent(item.data.parent)
                    if (navItem != '') {
                        parent.subItems.push(navItem);
                    }
                } else {
                    if (navItem != '') {
                        NavigationList.push(navItem)
                    }
                }

            }*/
        })
        //this.getParent(Parent.NavLogout)

        this.sortListByOrder(NavigationList)

        return NavigationList;
    },
    sortListByOrder(list) {
        if (list) {
            list.sort((a, b) => {
                ////console.log(a);
                return (a.order > b.order) ? 1 : -1
            })

            list.forEach((item) => {
                if (item.subItems.length > 0) {
                    this.sortListByOrder(item.subItems)
                }
            })
        }
    },
    getParent(parent) {
        var _parent = NavigationList.find((item) => item.id === parent.id);
        if (_parent != null) {
            return _parent;
        } else {
            NavigationList.push(parent)
            return parent;
        }
    },
}
export default AdminNavigation;